<template>
  <div id="primezordModal" class="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4">
    <div class="bg-[#0C1020] w-full max-w-md rounded-2xl p-6 shadow-2xl border border-[#d600c0] relative text-white">
      <button class="absolute top-4 right-4 text-gray-400 hover:text-[#d600c0] text-xl" @click="fechar">×</button>

      <!-- Etapa 1: Apresentação -->
      <template v-if="etapa === 'intro'">
        <h2 class="text-xl font-semibold mb-4">Assine o Primezord</h2>
        <p class="text-sm text-gray-300 mb-4 leading-relaxed">
          O Primezord é uma funcionalidade exclusiva para usuários premium que desejam automatizar suas estratégias de
          operação com robôs inteligentes.
        </p>

        <ul class="text-sm text-gray-400 mb-6 list-disc list-inside space-y-1">
          <li>Acesso a bots de alta performance</li>
          <li>Relatórios de resultados em tempo real</li>
          <li>Integração total com sua conta</li>
        </ul>

        <button
          class="bg-[#d600c0] hover:bg-[#b100a5] text-white font-semibold w-full py-2 rounded-md transition"
          @click="avancarParaConfirmacao"
        >
          {{ text }}
        </button>
      </template>

      <!-- Etapa 2: Confirmação -->
      <template v-else-if="etapa === 'confirm'">
        <h3 class="text-lg font-semibold mb-4">Confirmar assinatura</h3>
        <p class="text-sm text-gray-300 mb-6">
          A assinatura do primezord custa {{ subscriberPrimezordValue }}. Tem certeza que deseja ativar o Primezord?
          Esta ação não pode ser desfeita.
        </p>

        <div class="flex justify-end gap-3">
          <button class="bg-gray-600 hover:bg-gray-500 text-white px-4 py-2 rounded-md text-sm" @click="fechar">
            Cancelar
          </button>
          <button
            class="bg-[#d600c0] hover:bg-[#b100a5] text-white px-4 py-2 rounded-md text-sm"
            @click="assinarPrimezord"
          >
            Confirmar
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from '@/stores/integration'
import { useRouter } from 'vue-router'
import { useToast } from 'vuestic-ui'
import { computed, ref } from 'vue'

const appStore = useAppStore()
const router = useRouter()
const { init } = useToast()

const etapa = ref<'intro' | 'confirm'>('intro')
const text = ref('Assinar agora')
const subscriber = ref('')

function fechar() {
  etapa.value = 'intro'
  appStore.hidePrimezordModal()
}

async function avancarParaConfirmacao() {
  subscriber.value = await appStore.getBotSettings()
  console.log(subscriber.value)
  etapa.value = 'confirm'
}

async function assinarPrimezord() {
  text.value = 'Carregando...'
  const result = await appStore.robotSubscribe()

  if (!result.success) {
    init({ message: result.message, color: 'danger' })
    text.value = 'Assinar agora'
    return
  }

  init({ message: result.message, color: 'success' })
  await router.push({ name: 'primezord' })
  fechar()
}

const subscriberPrimezordValue = computed(() =>
  Number(subscriber.value || 0).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
  }),
)
</script>
